import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { toast } from "react-toastify";
import { Capitalize, CATCH_MESSAGE, getImage } from "../../../UtilityFunctions";
import { Hotel } from "@mui/icons-material";
import wbApi from "../../../API/wbApi";
import CustomBreadcrumbs from "../../../Components/breadCrumb/CustomBreadcrumbs";
import NoDataComponent from "../../../Components/noDataComponent/NoDataComponent";
import { CurrentProperty } from "../../../redux/actions/PropertiesAction";
import { RootState } from "../../../redux/store";
import DropzoneArea from "../../../views/customDropzone/DropzoneArea";
import CardWrapper from "../../../views/datacard/CardWrapper";
import InputTextField from "../../../views/inputfield/InputTextField";
import Button from "../../../views/buttons/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as Icons from "@fortawesome/free-solid-svg-icons";

const EditNearbyplace = () => {
  // Data From Redux
  const { company_id, auth_token } = useSelector(
    (state: RootState) => state.auth
  );
  const { template_id } = useSelector((state: RootState) => state.template_id);
  const { defaultSectionId } = useSelector(
    (state: RootState) => state.sections
  );

  const navigate = useNavigate();
  const dispatch = useDispatch();

  // States
  const [nearbyBannerId, setNearbyBannerId] = useState<any>();
  const [nearbySectionDetails, setNearbySectionDetails] = useState<any>([]);
  const [nearbyPlaces, setNearbyPlaces] = useState<any>();
  const [allHotelsData, setAllHotelsData] = useState<any>([]);
  const [nearbyPlacesBannerImg, setNearbyPlacesBannerImg] = useState<any>([]);
  const [nearbyPlacesFile, setNearbyPlacesFile] = useState<any[]>([]);
  const [title, setTitle] = useState("");
  const [altText, setAltText] = useState("");
  const [description, setDescription] = useState<any>("");
  const [refreshList, setRefreshList] = useState<boolean>(false);
  const [charCount, setCharCount] = useState({
    child: 0,
    privacy: 0,
    terms_cond: 0,
    cancellation: 0,
  });
  const [loader, setLoader] = useState<boolean>(false);

  const accpNearbyFiles = (value: any) => {
    setNearbyPlacesFile(value);
  };

  const deleteNearbyFiles = (value: any) => {
    if (value) {
      delteNearbyFilesApi();
    }
  };

  const delteNearbyFilesApi = async () => {
    try {
      let deleteRes = await wbApi.post(
        `/wb/delete-dz-default-section-background-image`,
        {
          company_id: company_id,
          image_name: nearbySectionDetails.background_image,
          section_id: defaultSectionId,
          template_id: template_id,
        }
      );
      if (deleteRes.data.status === 1) {
        toast.success(deleteRes.data.message);
        nearbyPlacesApi();
      } else {
        toast.error(deleteRes.data.message);
        nearbyPlacesApi();
      }
    } catch {
      toast.error(CATCH_MESSAGE);
    }
  };

  function removeTags(str: String) {
    str = str.toString();
    const finalStr = str.replace(/&nbsp;/g, " ");
    return finalStr.replace(/(<([^>]+)>)/gi, ""); // Regular expression to identify HTML tags in the input string. Replacing the identified,HTML tag with a null string.
  }

  const saveHandler = () => {
    if (nearbyPlacesFile.length) {
      uploadHandler();
    } else {
      addUpdateNearbyPlaces("undefined");
    }
  };

  const uploadHandler = async () => {
    if (nearbyPlacesFile.length === 1) {
      setLoader(true);
      let payload = new FormData();
      payload.append("uploadFile[0]", nearbyPlacesFile[0]);
      try {
        let uploadRes = await wbApi.post(
          `/wb/insert-dz-images/${company_id}/${template_id}/nearby_background_image`,
          payload,
          {
            headers: {
              Authorization: "Bearer " + auth_token,
            },
          }
        );
        // console.log("uploadRes", uploadRes);
        if (uploadRes.data.status === 1) {
          toast.success(uploadRes.data.message);
          await addUpdateNearbyPlaces(uploadRes.data.image_ids);
          setLoader(false);
        } else {
          toast.error(uploadRes.data.message);
          setLoader(false);
        }
      } catch {
        toast.error(CATCH_MESSAGE);
        setLoader(false);
      }
    } else {
      toast.error("Only One Image Allowed !")
    }

  };

  // Update ContactUs Section
  const addUpdateNearbyPlaces = async (testimonialBannerImgId: any) => {
    setLoader(true);
    try {
      let req = await wbApi.post("/wb/insert-update-default-section-details", {
        id: nearbyBannerId ?? "undefined",
        background_image: testimonialBannerImgId ?? "undefined",
        background_image_alt: altText,
        company_id: company_id,
        section_id: defaultSectionId,
        section_title: title,
        template_id: template_id,
        section_description: description,
      });
      if (req.data.status === 1) {
        toast.success(req.data.message);
        nearbyPlacesApi();
        setRefreshList(!refreshList);
        setLoader(false);
      } else {
        toast.error(req.data.message);
        nearbyPlacesApi();
        setLoader(false);
      }
    } catch (error) {
      setLoader(false);
      toast.error(CATCH_MESSAGE);
    }
  };

  const nearbyPlacesApi = async () => {
    try {
      const resp = await wbApi.get(
        `wb-dashboard/fetch-wb-nearby-places/${company_id}/${template_id}/${defaultSectionId}`
      );
      if (resp.data.status === 1) {
        setNearbyPlaces(resp?.data?.nearby_places);
        setAllHotelsData(resp?.data?.all_hotels_data);
        setNearbySectionDetails(resp?.data?.nearby_section_details);
        setNearbyBannerId(resp?.data?.nearby_section_details?.id);
        setTitle(resp?.data?.nearby_section_details?.section_title);
        setAltText(resp?.data?.nearby_section_details?.background_image_alt);
        if (resp?.data?.nearby_section_details?.background_image) {
          setNearbyPlacesBannerImg([
            getImage(resp?.data?.nearby_section_details?.background_image),
          ]);
        } else {
          setNearbyPlacesBannerImg([]);
        }
        setDescription(resp?.data?.nearby_section_details?.section_description ?? "");
      } else {
        setNearbyPlaces([]);
        setAllHotelsData([]);
        setNearbySectionDetails([]);
      }
    } catch {
      toast.error(CATCH_MESSAGE);
    }
  };
  useEffect(() => {
    nearbyPlacesApi();
  }, []);

  return (
    <>
      <div className="wb-subheader">
        <CustomBreadcrumbs
          content={[
            {
              label: "Sections",
              href: "/section-default",
            },
            {
              label: `Default Section`,
              href: "/section-default",
            },
            {
              label: "Edit Near By Places",
            },
          ]}
        />
        <div className="wb-subheader-rightsec">
          <Button
            icon="bi bi-arrow-left"
            className="bck-btn"
            handleClick={() => {
              navigate(-1);
            }}
          >
            Back
          </Button>
        </div>
      </div>
      <div className="wb-divider"></div>

      {/* -------------------------------- */}

      <CardWrapper className=" mt-4 mb-4 edit-promo-conatiner">
        <div className="edit-aboutus-text-container">
          <InputTextField
            label="Enter Title"
            value={title}
            className="edit-aboutus-subheader"
            handleChange={(e) => {
              setTitle(e.target.value);
            }}
          />
          <InputTextField
            label="Alternate Text"
            value={altText}
            className="edit-aboutus-alt-text"
            handleChange={(e) => {
              setAltText(e.target.value);
            }}
          />
        </div>
        <div className="edit-promo-alt-label">Select Back Ground Image</div>
        <div className="edit__dropzone__container">
          <DropzoneArea
            centerMesage={"Drag your photos or click here (1 Image Only)"}
            incomingfiles={nearbyPlacesBannerImg}
            dispatchFiles={(val) => accpNearbyFiles(val)}
            isDelete={(val) => deleteNearbyFiles(val)}
            acceptFileExt="image/jpg,image/jpeg,image/png,image/gif"
            refresh={refreshList}
          />
        </div>

        <div
          className="sec-description-editor"
          style={{ margin: "1.5rem 0rem" }}
        >
          <CKEditor
            editor={ClassicEditor}
            data={description}
            config={{
              removePlugins: [
                "EasyImage",
                "ImageUpload",
                "MediaEmbed",
                "Table",
              ],
            }}
            onChange={(event: string, editor: any) => {
              const data = editor.getData();
              setDescription(data);
              setCharCount({
                ...charCount,
                terms_cond: removeTags(data).length,
              });
            }}
          />
        </div>

        <div className="edit-contact-btn-container">
          <Button
            className="cancel__btn"
            handleClick={() => {
              navigate(-1);
            }}
          >
            Cancel
          </Button>
          <Button
            className="savebtn"
            handleClick={() => {
              saveHandler();
            }}
            loader={loader}
          >
            Save
          </Button>
        </div>
      </CardWrapper>

      <div className="select__hotel__label">Select Hotels</div>
      <div className="default_section_image_card_container mt-3">
        {allHotelsData?.length > 0 ? (
          allHotelsData?.map((item: any) => (
            <div
              key={item.hotel_id}
              className="default__setion__image mr-2"
              onClick={() => {
                navigate(
                  `/section-default/edit-nearby-places/edit-nearplaces-by-map`
                );
                dispatch(CurrentProperty(item));
              }}
            >
              <div className="image__container">
                {
                  item?.hotel_image ? (
                    <img
                      src={item.hotel_image}
                      alt={item.hotel_name}
                      className="default__setion__image__image"
                    />
                  ) : (
                    <div className="image_container_icon_wrapper">
                      <FontAwesomeIcon icon={Icons.faHotel} size="2x" color="blue" />
                    </div>

                  )

                }
                <div className="hotel__name">{Capitalize(item.hotel_name)}</div>
              </div>
            </div>
          ))
        ) : (
          <NoDataComponent message={"No Hotels Found"} />
        )}
      </div>
      <div className="sixtypx-height"></div>
    </>
  );
};

export default EditNearbyplace;
